import { Box, Text } from '@betterment/samba-react';
import { css } from '@betterment/samba-styled-system/css';
import { SambaAutoLink } from '@betterment/shared-components';

import { trackClick } from '../../../features/track';
import { urlBuilder } from '../../urlBuilder';

type ArticleProps = {
  id: string;
  title: string;
  imageUrl: string;
  imageAltText: string;
  readDuration: string;
};

export const Article: React.FC<ArticleProps> = ({ title, id, imageUrl, imageAltText, readDuration }) => {
  return (
    <div className="group">
      <SambaAutoLink
        to={urlBuilder.appBlogPost.absolute({ postId: id })}
        css={{ textDecoration: 'none!important' }}
        onClick={() => trackClick({ name: title, module: 'SuggestedContentPosts' })}
      >
        <Box css={{ display: 'flex', alignItems: 'center', gap: 'space.300' }}>
          <img
            src={imageUrl}
            alt={imageAltText}
            width={80}
            height={80}
            className={css({
              objectFit: 'cover',
              borderRadius: 'medium',
            })}
          />
          <Box>
            <Text
              as="p"
              variant="text100"
              color="text"
              css={{
                textDecoration: {
                  _groupHover: 'underline',
                },
              }}
            >
              {title}
            </Text>
            <Text variant="text50" color="text.weak">
              {readDuration}
            </Text>
          </Box>
        </Box>
      </SambaAutoLink>
    </div>
  );
};
